import { Component, computed, input } from '@angular/core';
import {
  ReservationStatus,
  ReservationStatusesDisplayNames
} from '@app/features/operations/reservations/reservations.model';

@Component({
  selector: 'app-reservation-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './reservation-status-badge.component.html',
  styleUrl: './reservation-status-badge.component.scss'
})
export class ReservationStatusBadgeComponent {
  status = input.required<ReservationStatus>();
  displayName = computed(() => ReservationStatusesDisplayNames[this.status()]);
}
